import { useCallback, useEffect } from "react";
/**
 * @callback useDebouncedEffectCallback
 *
 * @param {useDebouncedEffectCallback} effect
 * @param {number} delay
 * @param {string[]} deps
 */
export const useDebouncedEffect = (effect, delay, deps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callback = useCallback(effect, deps);

  useEffect(() => {
    const handler = setTimeout(() => {
      callback();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [callback, delay]);
};
